import type { CampaignCardView } from "../../../shared/types/campaign-card.type";
import {
	fmtMoney,
	fmtNum,
	fmtRoiPct,
	signedMetricModifier,
} from "../../../shared/utils/campaign-metrics-format";
import { KpiCard, KpiStrip } from "./KpiCard";

type Props = {
	campaign: CampaignCardView;
};

export const CampaignKpiSection = ({ campaign }: Props) => {
	const m = campaign.metrics;
	const budget = m.budget ?? 0;
	const spentPct =
		budget > 0 ? Math.round((m.cost / budget) * 100) : 0;

	return (
		<>
			<KpiStrip>
				<KpiCard
					label='Budget'
					value={fmtMoney(budget)}
					sub={budget > 0 ? `Spent ${spentPct}%` : undefined}
					editable={campaign.isEditable}
				/>
				<KpiCard label='Cost' value={fmtMoney(m.cost)} />
				<KpiCard
					label='Profit'
					value={fmtMoney(m.profit)}
					valueClassName={signedMetricModifier(m.profit)}
				/>
				<KpiCard
					label='ROI'
					value={m.roi != null ? fmtRoiPct(m.roi) : "—"}
					valueClassName={
						m.roi != null ? signedMetricModifier(m.roi) : undefined
					}
				/>
				<KpiCard
					label='Installs'
					value={fmtNum(m.inst)}
					sub={`CPI ${fmtMoney(m.cpi)}`}
				/>
				<KpiCard
					label='Revenue'
					value={fmtMoney(m.dep_sum)}
					sub={`${fmtNum(m.dep)} count`}
				/>
				<KpiCard
					label='tCPA'
					value={m.tcpa != null ? fmtMoney(m.tcpa) : "—"}
					editable={campaign.isEditable}
				/>
				<KpiCard
					label='CPA'
					value={m.cpa != null ? fmtMoney(m.cpa) : "—"}
				/>
			</KpiStrip>

			<div className='campaign-detail__settings-grid'>
				<div className='campaign-detail__settings-panel campaign-detail__settings-panel--geo'>
					<div className='campaign-detail__settings-block'>
						<div className='campaign-detail__settings-header'>
							<div className='campaign-detail__settings-label'>GEO</div>
							{campaign.isEditable && (
								<button
									type='button'
									className='campaign-detail__settings-edit'
									disabled>
									Edit
								</button>
							)}
						</div>
						<div className='campaign-detail__settings-value'>
							{campaign.geo.map((g) => g.country).join(", ") || "—"}
						</div>
					</div>
				</div>
				<div className='campaign-detail__settings-panel'>
					<div>
						<div className='campaign-detail__settings-label'>Ad Groups</div>
						<div className='campaign-detail__settings-value'>
							{campaign.adgroups.length}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
